<template>
    <div class="kmn-text-box-container">
        <RichTextBox
            ref="smsTextBox"
            v-model="localValue"
            class="manager-text-box"
            :has-error="hasError"
            :hide-border="true"
        >
            <template #footer>
                <KeapMarketingSmsTemplateManagerFooter
                    :has-error="hasError"
                    :contains-supported-character="containsSupportedCharacter"
                    :max-length="maxLength"
                    :character-count-label="characterCountLabel"
                    :merge-field-categories="mergeFieldCategories"
                    :saving="saving"
                    :saved="saved"
                    @insert-template="insertTemplate"
                />
            </template>
        </RichTextBox>
    </div>
</template>

<script>
import KeapMarketingSmsTemplateManagerFooter from './KeapMarketingSmsTemplateManagerFooter';

export default {
    components: {
        KeapMarketingSmsTemplateManagerFooter,
        RichTextBox: () => import(/* webpackChunkName: "RichTextBox" */ '@/components/automatedSms/RichTextBox'),
    },

    props: {
        hasError: Boolean,
        value: {
            type: String,
            default: '',
        },
        containsSupportedCharacter: Boolean,
        maxLength: Number,
        characterCountLabel: String,
        mergeFieldCategories: Array,
        saving: Boolean,
        saved: Boolean,
    },

    data() {
        return {
            localValue: this.value,
        };
    },

    watch: {
        value(val) {
            if (this.localValue !== val) {
                this.localValue = val;
            }
        },

        localValue(val) {
            if (val !== this.value) {
                this.$emit('input', val);
            }
        },
    },

    methods: {
        insertTemplate() {
            this.$emit('insert-template');
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .kmn-text-box-container {
        height: 100%;
    }

    .manager-text-box {
        height: 70%;
        overflow-y: auto;
        max-width: px-to-rem(600);
    }
</style>
